import Vue                      from 'vue'
import VueMeta                  from 'vue-meta'
import axios, { AxiosAdapter }  from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import Bugsnag                  from '@bugsnag/js'
import BugsnagPluginVue         from '@bugsnag/plugin-vue'
import { library }              from '@fortawesome/fontawesome-svg-core'
import {
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleDoubleUp,
	faAngleLeft,
	faAngleRight,
	faArrowsAltH,
	faArrowsAltV,
	faArrowUp,
	faBars,
	faBook,
	faChessRook,
	faChevronDown,
	faExternalLink,
	faHashtag,
	faHeart      as fasHeart,
	faInfinity,
	faPlus,
	faRedoAlt,
	faScrewdriverWrench,
	faThumbsUp   as fasThumbsUp,
	faThumbsDown as fasThumbsDown,
}                               from '@fortawesome/free-solid-svg-icons'
import {
	faCircleCheck,
	faCircleXmark,
	faEye,
	faEyeSlash,
	faHeart      as farHeart,
	faNewspaper,
	faThumbsUp   as farThumbsUp,
	faThumbsDown as farThumbsDown,
}                               from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon }      from '@fortawesome/vue-fontawesome'
import App                      from './App.vue'
import datetime                 from './filters/datetime'
import router                   from './router'
import store                    from './store'

if (process.env.NODE_ENV === 'production') {
	Bugsnag.start({
		apiKey  : '6a67b2d1fd79f886b6770e2d21a9b902',
		plugins : [ new BugsnagPluginVue() ],
	})

	const bugsnagVue = Bugsnag.getPlugin('vue')

	if (!!bugsnagVue)
		bugsnagVue.installVueErrorHandler(Vue)
}

// Solid icons
library.add(
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleDoubleUp,
	faAngleLeft,
	faAngleRight,
	faArrowsAltH,
	faArrowsAltV,
	faArrowUp,
	faBars,
	faBook,
	faChessRook,
	faChevronDown,
	faExternalLink,
	faHashtag,
	fasHeart,
	faInfinity,
	faPlus,
	faRedoAlt,
	faScrewdriverWrench,
	fasThumbsUp,
	fasThumbsDown,
)

// Regular icons
library.add(
	faCircleCheck,
	faCircleXmark,
	faEye,
	faEyeSlash,
	farHeart,
	faNewspaper,
	farThumbsUp,
	farThumbsDown,
)

const http = axios.create({
	baseURL : 'https://api.tropicaltowerwars.com/',
	adapter : cacheAdapterEnhancer(axios.defaults.adapter as AxiosAdapter, {
		enabledByDefault : false,
	}),
})

Vue.config.productionTip = false
Vue.prototype.$http = http

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.filter('datetime', datetime)
Vue.use(VueMeta)

new Vue({
	router,
	store,
	render : h => h(App),
}).$mount('#app')
